import { Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import AdminLayout from "../layouts/AdminLayout";

import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";

import Home from "../pages/Home";
import Services from "../pages/Services";
import Booking from "../pages/Booking";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Profile from "../pages/Profile";
import Contact from "../pages/Contact";
import Gallery from "../pages/Gallery";
import VerifyEmail from "../pages/VerifyEmail";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import BookingConfirmation from "../pages/BookingConfirmation";
import BookingCancel from "../pages/BookingCancel";
import ActionStatus from "../pages/ActionStatus";

import Dashboard from "../admin/Dashboard";
import ManageServices from "../admin/ManageServices";
import ManageBookings from "../admin/ManageBookings";
import ManageAvailability from "../admin/ManageAvailability";
import ManageUsers from "../admin/ManageUsers";
import Analytics from "../admin/Analytics";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="booking" element={<Booking />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="contact" element={<Contact />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="booking-confirmation" element={<BookingConfirmation />} />
        <Route path="booking-cancel" element={<BookingCancel />} />
        <Route path="action-status" element={<ActionStatus />} />

        <Route
          path="profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
      </Route>

      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="services" element={<ManageServices />} />
        <Route path="bookings" element={<ManageBookings />} />
        <Route path="availability" element={<ManageAvailability />} />
        <Route path="users" element={<ManageUsers />} />
        <Route path="analytics" element={<Analytics />} />
      </Route>

      <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;